module.exports = __webpack_public_path__ + "static/media/appointment-finishing.c187d2c6.svg";